import React from 'react'
import { IconComponent, PointerProgressComponent, ProgressComponent, PictureProgress, JumpHotAreaComponent, NumberComponent } from '../../components'
// import TimeNumberComponent from './TimeNumberComponent'
import TimeNumberComponentWithRect from './TimeNumberComponentWithRect'

const componentMap = (hasRectArea) => ({
  text: hasRectArea ? TimeNumberComponentWithRect : NumberComponent,
  current: hasRectArea ? TimeNumberComponentWithRect : NumberComponent,
  high: hasRectArea ? TimeNumberComponentWithRect : NumberComponent,
  low: hasRectArea ? TimeNumberComponentWithRect : NumberComponent,
  icon: IconComponent,
  pointer_progress: PointerProgressComponent,
  progress: ProgressComponent,
  image_progress: PictureProgress,
  jumpable: JumpHotAreaComponent
})

class Sun extends React.Component {
  static renderLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]
    if (Component && Component.renderLayer) {
      Component.renderLayer({ childKey, ...restArgs })
    }
  }

  static removeLayer = ({ childKey, hasRectArea, ...restArgs }) => {
    const Component = componentMap(hasRectArea)[childKey]

    if (Component && Component.removeLayer) {
      Component.removeLayer({ childKey, ...restArgs })
    }
  }

  render() {
    const { childKey, propMap } = this.props
    const prop = propMap[childKey] || {}
    const { hasRectArea } = prop
    const Component = componentMap(hasRectArea)[childKey]
    const allProps = { ...this.props, ...prop }

    if (childKey === 'image_progress') {
      return <PictureProgress {...allProps} />
    }
    return <div className="control-container">{Component && <Component {...allProps} />}</div>
  }
}

export default Sun
